import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import AOS from 'aos';
import {
  FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock,
  FaLinkedin, FaTwitter, FaFacebook, FaCheckCircle, FaPaperPlane
} from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  useEffect(() => { AOS.init({ duration: 900, once: true, offset: 80 }); }, []);

  const [form, setForm] = useState({
    name: '', email: '', phone: '', company: '', service: '', message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = e => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = e => {
    e.preventDefault();
    // Placeholder — wire to API later
    setSubmitted(true);
  };

  const SERVICES = [
    'Custom Software Development', 'AI & ML Solutions', 'ERP / CRM / HRMS',
    'E-Commerce Platform', 'Mobile App Development', 'Cloud & DevOps',
    'TalentX Training', 'TalentForce Staffing', 'PromoX Marketing', 'Other'
  ];

  return (
    <div className="contact-page">

      <section className="page-hero">
        <div className="page-hero-overlay" />
        <Container>
          <div className="page-hero-content" data-aos="fade-up">
            <div className="breadcrumb-vk"><Link to="/">Home</Link> / <span>Contact</span></div>
            <h1 className="page-hero-title">
              Let's Build Your<br />
              <span>Next Digital Product</span>
            </h1>
            <p className="page-hero-desc">
              Reach out to discuss your project, request a demo, or just say hello.
              Our team typically responds within 2 business hours.
            </p>
          </div>
        </Container>
      </section>

      <section className="section-py" style={{ background: 'var(--color-bg)' }}>
        <Container>
          <Row className="g-5">

            {/* Contact Info */}
            <Col lg={4} data-aos="fade-right">
              <div className="contact-info-panel">
                <h3 className="contact-info-title">Get in Touch</h3>
                <p className="contact-info-sub">We're here to help and answer any question you might have.</p>

                {[
                  { icon: <FaPhone />, label: 'Phone', value: '+91 44 - 40066713', href: 'tel:+914440066713', color: '#1e40af' },
                  { icon: <FaEnvelope />, label: 'Email', value: 'contactus@vkomaktechnologies.com', href: 'mailto:contactus@vkomaktechnologies.com', color: '#0891b2' },
                  { icon: <FaMapMarkerAlt />, label: 'Address', value: 'Chennai – Saidapet, Tamil Nadu, India', href: null, color: '#dc2626' },
                  { icon: <FaClock />, label: 'Business Hours', value: 'Mon–Sat: 9:00 AM – 7:00 PM IST', href: null, color: '#7c3aed' },
                ].map((item, i) => (
                  <div key={i} className="contact-info-item">
                    <div className="contact-info-icon" style={{ background: `${item.color}12`, color: item.color }}>{item.icon}</div>
                    <div>
                      <div className="contact-info-label">{item.label}</div>
                      {item.href ? (
                        <a href={item.href} className="contact-info-value">{item.value}</a>
                      ) : (
                        <div className="contact-info-value">{item.value}</div>
                      )}
                    </div>
                  </div>
                ))}

                <div className="contact-social">
                  <p className="contact-social-label">Follow us</p>
                  <div className="contact-social-links">
                    {[
                      { icon: <FaLinkedin />, href: 'https://linkedin.com', color: '#0077b5' },
                      { icon: <FaTwitter />, href: 'https://twitter.com', color: '#1da1f2' },
                      { icon: <FaFacebook />, href: 'https://facebook.com', color: '#1877f2' },
                    ].map((s, i) => (
                      <a key={i} href={s.href} target="_blank" rel="noreferrer" className="social-btn" style={{ '--social-color': s.color }}>
                        {s.icon}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </Col>

            {/* Contact Form */}
            <Col lg={8} data-aos="fade-left">
              <div className="contact-form-panel">
                {submitted ? (
                  <div className="contact-success">
                    <FaCheckCircle className="success-icon" />
                    <h3>Thank You!</h3>
                    <p>Your message has been received. Our team will contact you within 2 business hours.</p>
                    <button className="btn-primary-vk" onClick={() => setSubmitted(false)}>Send Another</button>
                  </div>
                ) : (
                  <>
                    <h3 className="form-title">Send Us a Message</h3>
                    <p className="form-sub">Fill in the details below and we'll get back to you quickly.</p>
                    <form onSubmit={handleSubmit} className="contact-form">
                      <Row className="g-3">
                        <Col md={6}>
                          <div className="form-group-vk">
                            <label htmlFor="name">Full Name *</label>
                            <input type="text" id="name" name="name" placeholder="John Doe" value={form.name} onChange={handleChange} required />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form-group-vk">
                            <label htmlFor="email">Email Address *</label>
                            <input type="email" id="email" name="email" placeholder="you@company.com" value={form.email} onChange={handleChange} required />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form-group-vk">
                            <label htmlFor="phone">Phone Number</label>
                            <input type="tel" id="phone" name="phone" placeholder="+91 XXXXX XXXXX" value={form.phone} onChange={handleChange} />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form-group-vk">
                            <label htmlFor="company">Company Name</label>
                            <input type="text" id="company" name="company" placeholder="Your Company" value={form.company} onChange={handleChange} />
                          </div>
                        </Col>
                        <Col md={12}>
                          <div className="form-group-vk">
                            <label htmlFor="service">Service Interested In</label>
                            <select id="service" name="service" value={form.service} onChange={handleChange}>
                              <option value="">Select a service...</option>
                              {SERVICES.map((s, i) => <option key={i} value={s}>{s}</option>)}
                            </select>
                          </div>
                        </Col>
                        <Col md={12}>
                          <div className="form-group-vk">
                            <label htmlFor="message">Message *</label>
                            <textarea id="message" name="message" rows="5" placeholder="Tell us about your project, requirements, or questions..." value={form.message} onChange={handleChange} required />
                          </div>
                        </Col>
                        <Col md={12}>
                          <button type="submit" className="btn-primary-vk form-submit-btn">
                            Send Message <FaPaperPlane />
                          </button>
                          <p className="form-privacy">By submitting, you agree to our privacy policy. We'll never share your data.</p>
                        </Col>
                      </Row>
                    </form>
                  </>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

    </div>
  );
};

export default Contact;
